export default __webpack_public_path__ + "static/media/longchamp25.d1f3a440.jpg";